<template>
  <nav>
    <ul>
      <li v-for="anchor in anchors" :key="anchor.id">
        <button
          type="button"
          class="button-index"
          @click.prevent="handleClick(anchor)"
        >
          {{ anchor.label }}
        </button>
      </li>
    </ul>
  </nav>
</template>
<script lang="ts" setup>
import { INJECT_ANCHORS } from '~/composables/anchor/useAnchors';
import type { AnchorLink } from '~/types/ui';

const anchorsList = inject(INJECT_ANCHORS);

const { anchors, offset } = anchorsList;

const scrollToPosition = (position, behavior: ScrollBehavior) => {
  const scollY = position - offset.value - 10; // 10 is arbitrary
  window.scrollTo({
    top: scollY,
    behavior,
  });
};

const handleClick = (anchor: AnchorLink) => {
  scrollToPosition(anchor.position, 'smooth');
};
const debouncedScroll = useDebounceFn((anchor) => {
  scrollToPosition(anchor.position, 'auto');
}, 1);

const scrolled = ref<boolean>(false);
const route = useRoute();

onMounted(() => {
  const id = route.hash.replace('#', '');
  const anchor = anchors.value.find((anchor) => anchor.id === id);
  if (!scrolled.value && id && anchor) {
    debouncedScroll(anchor);
  }
});
</script>
<style lang="scss" scoped>
ul {
  padding: 0 0 0 1.2rem;
  list-style: circle;
}
li {
  margin: 0 0 0 0.8rem;
  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  // display: flex;
}
.button-index {
  display: block;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0;
  transition: color 250ms $ease-out-quad;
  color: var(--color_neutral_600);
  text-align: left;
  @include font('n', 600);
  .icon {
    position: relative;
    top: -0.1rem;
  }
  &:hover,
  &:focus {
    color: var(--color_secondary);
  }
}
</style>
